import { DispatchType } from "@bridgesplit/react";

import { EXPLORE_LOOPS_FILTER_CONFIG, EXPLORE_VAULTS_FILTER_CONFIG } from "../constants/filters";

/** Label structure for filter buttons */
export type PluralLabelText = {
    desktop: {
        all: string;
        single: string;
        multi: string;
    };
    mobile?: {
        all?: string;
        single?: string;
        multi?: string;
    };
};

/** Filter types available */
export enum FilterType {
    Boolean = "Boolean",
    InclusiveBoolean = "InclusiveBoolean",
    MultiSelect = "MultiSelect",
    SingleSelect = "SingleSelect"
}

/** Base return types per filter type */
export type FilterReturnType = {
    [FilterType.Boolean]: boolean;
    [FilterType.InclusiveBoolean]: boolean;
    [FilterType.MultiSelect]: Set<string>;
    [FilterType.SingleSelect]: string;
};

/** Config maps filter keys to their filter type */
export type FilterConfig = {
    [filterKey: string]: keyof FilterReturnType;
};

export type FilterState<C extends FilterConfig> = {
    [K in keyof C]: {
        enabled: boolean;
        condition: FilterReturnType[C[K]];
    };
};

/** Props shared across filter components */
export type FilterProps<C extends FilterConfig> = {
    filters: FilterState<C>;
    defaultState: FilterState<C>;
    setFilters: DispatchType<FilterState<C>>;
};

export type ExploreLoopsFilters = typeof EXPLORE_LOOPS_FILTER_CONFIG;

export type ExploreVaultsFilters = typeof EXPLORE_VAULTS_FILTER_CONFIG;

export type FilterContentProps<T> = {
    pending: T;
    setPending: DispatchType<T>;
};
